var _ = require('underscore'),
    TopDownResult = require('./topDownResult');



/**
 * Could have an OBJ with map of pg_id, search_id, but just doing an array -- or even BB Collection ( actually a good use case for that )
 * Wrapping and not sub-classing the Array -- this is not possible in ES5 -- Array's are 'exotic' objects ....
 */

var TopDownResults = function() {

    this.results = [];

};



_.extend( TopDownResults.prototype, {

    getResults: function() {
        return this.results;
    },

    getResultByPageAndSearchId: function( pageId, searchId ) {

        return _.find( this.getResults(), function(r) {
            return r.searchId === searchId && r.pageId === pageId;
        });

    },

    hasResult: function( pageId, searchId ) {

        return this.getResultByPageAndSearchId( pageId, searchId ) !== undefined;

    },

    addNewResult: function( pageId, searchId, pageNote, search ) {

        var result = new TopDownResult( pageId, searchId, pageNote, search );
        this.results.push( result );

        return result;

    },


    getUniqueSearchIds: function() {

        return _.uniq( this.results.map( function( r) {
            return r.searchId;
        }));

    },

    getUniqueSearches: function() {

        var searchIdBySearchMap = {};

        this.results.forEach( function( r ) {

            var search = r.getSearch();
            searchIdBySearchMap[search.cid] = search; // TODO: use function to return identifier throughout app as it may chance

        });

        return Object.values( searchIdBySearchMap );

    },

    /* Note: currently mutatable method -- go backwards to keep index as it's re-indexed by splice in the loop */
    removeAllResultsOfSearch: function( searchId ) {

        var results = this.results;
        for ( var i= results.length -1 ; i > -1; i-- ) {
            if ( results[i].searchId === searchId ) {
                this.results.splice( i, 1 );
            }
        }

    },

    getResultsOfPage: function( pageId ) {

        return this.getResults().filter( function(r) {
            return r.getPageId() === pageId;
        });

    },

    /* Could argue to use the hierarchy but not that is primarily for the UI */
    pageHasResultsFromFloatingRedactions: function( pageId ) {

        return this.getResults().filter( function(r) {
            return r.getPageId() === pageId && r.getNote().isFloatingRedaction();
        });


    },

    getFloatingReasonCodesNotesOfPage: function( pageId ) {

        return this.getResults().reduce( function( prev, current ) {

            if ( current.getPageId() !== pageId )
                return prev;

            var note = current.getNote();

            if ( note.isFloatingRedaction() && prev.map( function(p) { return p.cid; }).indexOf( note.cid ) < 0 )  {
                return prev.concat(note);
            } else {
                return prev;
            }

        } , [] );

    },



    clear: function() {
        while ( this.results.length > 0) {
            this.results.pop();
        }
    }


});



module.exports = TopDownResults;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/topDownResults/topDownResults.js
 ** module id = 664
 ** module chunks = 0
 **/